import FrameworkList from "./pages/ListPage.vue";
import FrameworkDetail from "./pages/FormPage.vue";
import FrameworkIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/framework",
    component: FrameworkIndex,
    redirect: "/framework/list",
    name: "framework",
    children: [
      {
        path: "list",
        component: FrameworkList,
        name: "framework.list",
      },
      {
        path: "create",
        component: FrameworkDetail,
        name: "framework.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: FrameworkDetail,
        name: "framework.edit",
        props: { create: false },
      },
    ],
  },
];
